// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"352":"vendor.muiDataGrid","670":"vendor.apexCharts"}[chunkId] || chunkId) + "." + {"199":"4ec116cac273f8daa450","352":"e71ee120109b77944754","670":"ce87c0473c34b44da73c","781":"6619c740ce346ae7401e","888":"1b86f080df4a5c5d2c4d"}[chunkId] + ".js";
};